import styles from "./EditRole.module.scss";
import secondaryComponents from "../../../../../../components/secondaryComponents";
import primaryComponents from "../../../../../../components/primaryComponents";
import { Controller } from "react-hook-form";
import useEditRole from "./useEditRole";
import EditRoleVaidation from "./EditRoleValidation";
import { useEffect } from "react";
import PermissionCheckBox from "./PermissionCheckBox";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const EditRoleModal = ({ showEditRoleModal, setShowEditRoleModal }) => {
  const {
    isLoadingSingleRole,
    dataSingleRole,
    showPermission,
    roleName,
    setRoleName,
    expenseApprovalLimit,
    setExpenseApprovalLimit,
    hanldeEditRole,
    isLoadingPermissionCategory,
    isLoadingMutate,
    dataPermissionsCategory,
    selectedPermissions,
    selectAllAccounting,
    selectAllCustomers,
    selectAllExpense,
    selectAllInventoryManagement,
    selectAllLoyalty,
    selectAllPayments,
    selectAllSettings,
    setShowPermission,
    setSelectedPermissions,
    setSelectAllAccounting,
    setSelectAllCustomers,
    setSelectAllExpense,
    setSelectAllInventoryManagement,
    setSelectAllLoyalty,
    setSelectAllPayments,
    setSelectAllSettings,
  } = useEditRole({ showEditRoleModal, setShowEditRoleModal });

  const {
    control,
    formState: { errors },
    handleSubmit,
    register,
    trigger,
    setValue,
  } = EditRoleVaidation(roleName);

  useEffect(() => {
    setValue("label", roleName);
  }, [roleName]);

  useEffect(() => {
    setValue("expense_approval_limit", expenseApprovalLimit);
  }, [expenseApprovalLimit]);

  return (
    <secondaryComponents.Modal
      width="550px"
      isActive={showEditRoleModal ? true : false}
      closeModal={() => {
        setShowEditRoleModal(false);
      }}
    >
      <div className={styles.modal_container}>
        <h3>Edit Role</h3>
        <p>
          Edit roles that are unique to your organization and choose what they
          can see and do
        </p>
        <secondaryComponents.LoaderHelper
          classNames="mt-5"
          isLoading={
            isLoadingSingleRole ||
            !dataSingleRole ||
            isLoadingPermissionCategory ||
            !dataPermissionsCategory
          }
        >
          <form
            onSubmit={handleSubmit(hanldeEditRole)}
            className={styles.form_container}
          >
            <div>
              <Controller
                name="label"
                control={control}
                defaultValue={roleName}
                render={({ field: { onChange } }) => (
                  <primaryComponents.InputField
                    label="Role name"
                    value={roleName}
                    placeholder="Enter the name of the unique role"
                    classNames="white"
                    isRequired={true}
                    type="text"
                    name="label"
                    errorMessage={errors.label}
                    onKeyUp={() =>
                      errors.label !== undefined && trigger("label")
                    }
                    onChange={({ target: { value } }) => {
                      onChange(value);
                      setRoleName(value);
                    }}
                    register={register}
                  />
                )}
              />
            </div>
            <div>
              <Controller
                name="expense_approval_limit"
                control={control}
                defaultValue={expenseApprovalLimit}
                render={({ field: { onChange } }) => (
                  <primaryComponents.AmountField
                    label="Expense Approval limit"
                    value={expenseApprovalLimit}
                    placeholder="Enter expense approval limit"
                    name="expense_approval_limit"
                    errorMessage={errors.expense_approval_limit}
                    onKeyUp={() =>
                      errors.expense_approval_limit !== undefined &&
                      trigger("expense_approval_limit")
                    }
                    onChange={({ target: { value } }) => {
                      onChange(value);
                      setExpenseApprovalLimit(value);
                    }}
                    register={register}
                  />
                )}
              />
            </div>
            <div>
              <div className={styles.permissions_text}>Permissions</div>
              <p className={styles.permissions_subtext}>
                This role can have access to:
              </p>

              <div className={styles.permission_container}>
                <div className={styles.permission_item}>
                  <div
                    onClick={() =>
                      setShowPermission(
                        showPermission.includes("Inventory Management")
                          ? showPermission.filter(
                              (item) => item !== "Inventory Management",
                            )
                          : [
                              ...new Set([
                                ...showPermission,
                                "Inventory Management",
                              ]),
                            ],
                      )
                    }
                    className={styles.permission_item_heading}
                  >
                    <p>Inventory Management</p>
                    <FontAwesomeIcon
                      className={`gray--text ${styles.transform_icon} ${
                        showPermission.includes("Inventory Management") &&
                        styles.active
                      }`}
                      icon="angle-down"
                      style={{ fontSize: "18px" }}
                    />
                  </div>
                  {showPermission.includes("Inventory Management") && (
                    <div className={styles.permission_item_body}>
                      <div className={styles.permission_value_all}>
                        <primaryComponents.Checkbox
                          isChecked={selectAllInventoryManagement}
                          id={"selectAllInventoryManagement"}
                          name={"selectAllInventoryManagement"}
                          onChange={() => {
                            const permissions = dataPermissionsCategory
                              ?.find(
                                (item) => item.label === "Inventory Management",
                              )
                              ?.permissions.map((item) => item.id);

                            if (selectAllInventoryManagement) {
                              const notInPermissions =
                                selectedPermissions.filter(
                                  (item) => !permissions.includes(item),
                                );

                              setSelectedPermissions(notInPermissions);
                            } else {
                              setSelectedPermissions([
                                ...new Set([
                                  ...selectedPermissions,
                                  ...permissions,
                                ]),
                              ]);
                            }
                            setSelectAllInventoryManagement(
                              !selectAllInventoryManagement,
                            );
                          }}
                        />
                        <p className="ml-2 mt-1">Select All</p>
                      </div>
                      {dataPermissionsCategory
                        ?.find((item) => item.label === "Inventory Management")
                        ?.permissions.map((perm) => (
                          <PermissionCheckBox
                            key={perm.id}
                            perm={perm}
                            selectedPermissions={selectedPermissions}
                            setSelectedPermissions={setSelectedPermissions}
                          />
                        ))}
                    </div>
                  )}
                </div>
                <div className={styles.permission_item}>
                  <div
                    onClick={() =>
                      setShowPermission(
                        showPermission.includes("Expense")
                          ? showPermission.filter((item) => item !== "Expense")
                          : [...new Set([...showPermission, "Expense"])],
                      )
                    }
                    className={styles.permission_item_heading}
                  >
                    <p>Expense</p>
                    <FontAwesomeIcon
                      className={`gray--text ${styles.transform_icon} ${
                        showPermission.includes("Expense") && styles.active
                      }`}
                      icon="angle-down"
                      style={{ fontSize: "18px" }}
                    />
                  </div>
                  {showPermission.includes("Expense") && (
                    <div className={styles.permission_item_body}>
                      <div className={styles.permission_value_all}>
                        <primaryComponents.Checkbox
                          isChecked={selectAllExpense}
                          id={"selectAllExpense"}
                          name={"selectAllExpense"}
                          onChange={() => {
                            const permissions = dataPermissionsCategory
                              ?.find((item) => item.label === "Expense")
                              ?.permissions.map((item) => item.id);

                            if (selectAllExpense) {
                              const notInPermissions =
                                selectedPermissions.filter(
                                  (item) => !permissions.includes(item),
                                );

                              setSelectedPermissions(notInPermissions);
                            } else {
                              setSelectedPermissions([
                                ...new Set([
                                  ...selectedPermissions,
                                  ...permissions,
                                ]),
                              ]);
                            }
                            setSelectAllExpense(!selectAllExpense);
                          }}
                        />
                        <p className="ml-2 mt-1">Select All</p>
                      </div>
                      {dataPermissionsCategory
                        ?.find((item) => item.label === "Expense")
                        ?.permissions.map((perm) => (
                          <PermissionCheckBox
                            key={perm.id}
                            perm={perm}
                            selectedPermissions={selectedPermissions}
                            setSelectedPermissions={setSelectedPermissions}
                          />
                        ))}
                    </div>
                  )}
                </div>
                <div className={styles.permission_item}>
                  <div
                    onClick={() =>
                      setShowPermission(
                        showPermission.includes("Payments")
                          ? showPermission.filter((item) => item !== "Payments")
                          : [...new Set([...showPermission, "Payments"])],
                      )
                    }
                    className={styles.permission_item_heading}
                  >
                    <p>Payments</p>
                    <FontAwesomeIcon
                      className={`gray--text ${styles.transform_icon} ${
                        showPermission.includes("Payments") && styles.active
                      }`}
                      icon="angle-down"
                      style={{ fontSize: "18px" }}
                    />
                  </div>
                  {showPermission.includes("Payments") && (
                    <div className={styles.permission_item_body}>
                      <div className={styles.permission_value_all}>
                        <primaryComponents.Checkbox
                          isChecked={selectAllPayments}
                          id={"selectAllPayments"}
                          name={"selectAllPayments"}
                          onChange={() => {
                            const permissions = dataPermissionsCategory
                              ?.find((item) => item.label === "Payments")
                              ?.permissions.map((item) => item.id);

                            if (selectAllPayments) {
                              const notInPermissions =
                                selectedPermissions.filter(
                                  (item) => !permissions.includes(item),
                                );

                              setSelectedPermissions(notInPermissions);
                            } else {
                              setSelectedPermissions([
                                ...new Set([
                                  ...selectedPermissions,
                                  ...permissions,
                                ]),
                              ]);
                            }
                            setSelectAllPayments(!selectAllPayments);
                          }}
                        />
                        <p className="ml-2 mt-1">Select All</p>
                      </div>
                      {dataPermissionsCategory
                        ?.find((item) => item.label === "Payments")
                        ?.permissions.map((perm) => (
                          <PermissionCheckBox
                            key={perm.id}
                            perm={perm}
                            selectedPermissions={selectedPermissions}
                            setSelectedPermissions={setSelectedPermissions}
                          />
                        ))}
                    </div>
                  )}
                </div>
                <div className={styles.permission_item}>
                  <div
                    onClick={() =>
                      setShowPermission(
                        showPermission.includes("Loyalty")
                          ? showPermission.filter((item) => item !== "Loyalty")
                          : [...new Set([...showPermission, "Loyalty"])],
                      )
                    }
                    className={styles.permission_item_heading}
                  >
                    <p>Loyalty</p>
                    <FontAwesomeIcon
                      className={`gray--text ${styles.transform_icon} ${
                        showPermission.includes("Loyalty") && styles.active
                      }`}
                      icon="angle-down"
                      style={{ fontSize: "18px" }}
                    />
                  </div>
                  {showPermission.includes("Loyalty") && (
                    <div className={styles.permission_item_body}>
                      <div className={styles.permission_value_all}>
                        <primaryComponents.Checkbox
                          isChecked={selectAllLoyalty}
                          id={"selectAllLoyalty"}
                          name={"selectAllLoyalty"}
                          onChange={() => {
                            const permissions = dataPermissionsCategory
                              ?.find((item) => item.label === "Loyalty")
                              ?.permissions.map((item) => item.id);

                            if (selectAllLoyalty) {
                              const notInPermissions =
                                selectedPermissions.filter(
                                  (item) => !permissions.includes(item),
                                );

                              setSelectedPermissions(notInPermissions);
                            } else {
                              setSelectedPermissions([
                                ...new Set([
                                  ...selectedPermissions,
                                  ...permissions,
                                ]),
                              ]);
                            }
                            setSelectAllLoyalty(!selectAllLoyalty);
                          }}
                        />
                        <p className="ml-2 mt-1">Select All</p>
                      </div>
                      {dataPermissionsCategory
                        ?.find((item) => item.label === "Loyalty")
                        ?.permissions.map((perm) => (
                          <PermissionCheckBox
                            key={perm.id}
                            perm={perm}
                            selectedPermissions={selectedPermissions}
                            setSelectedPermissions={setSelectedPermissions}
                          />
                        ))}
                    </div>
                  )}
                </div>
                <div className={styles.permission_item}>
                  <div
                    onClick={() =>
                      setShowPermission(
                        showPermission.includes("Accounting")
                          ? showPermission.filter(
                              (item) => item !== "Accounting",
                            )
                          : [...new Set([...showPermission, "Accounting"])],
                      )
                    }
                    className={styles.permission_item_heading}
                  >
                    <p>Accounting</p>
                    <FontAwesomeIcon
                      className={`gray--text ${styles.transform_icon} ${
                        showPermission.includes("Accounting") && styles.active
                      }`}
                      icon="angle-down"
                      style={{ fontSize: "18px" }}
                    />
                  </div>
                  {showPermission.includes("Accounting") && (
                    <div className={styles.permission_item_body}>
                      <div className={styles.permission_value_all}>
                        <primaryComponents.Checkbox
                          isChecked={selectAllAccounting}
                          id={"selectAllAccounting"}
                          name={"selectAllAccounting"}
                          onChange={() => {
                            const permissions = dataPermissionsCategory
                              ?.find((item) => item.label === "Accounting")
                              ?.permissions.map((item) => item.id);

                            if (selectAllAccounting) {
                              const notInPermissions =
                                selectedPermissions.filter(
                                  (item) => !permissions.includes(item),
                                );

                              setSelectedPermissions(notInPermissions);
                            } else {
                              setSelectedPermissions([
                                ...new Set([
                                  ...selectedPermissions,
                                  ...permissions,
                                ]),
                              ]);
                            }
                            setSelectAllAccounting(!selectAllAccounting);
                          }}
                        />
                        <p className="ml-2 mt-1">Select All</p>
                      </div>
                      {dataPermissionsCategory
                        ?.find((item) => item.label === "Accounting")
                        ?.permissions.map((perm) => (
                          <PermissionCheckBox
                            key={perm.id}
                            perm={perm}
                            selectedPermissions={selectedPermissions}
                            setSelectedPermissions={setSelectedPermissions}
                          />
                        ))}
                    </div>
                  )}
                </div>
                <div className={styles.permission_item}>
                  <div
                    onClick={() =>
                      setShowPermission(
                        showPermission.includes("Customers")
                          ? showPermission.filter(
                              (item) => item !== "Customers",
                            )
                          : [...new Set([...showPermission, "Customers"])],
                      )
                    }
                    className={styles.permission_item_heading}
                  >
                    <p>Customers</p>
                    <FontAwesomeIcon
                      className={`gray--text ${styles.transform_icon} ${
                        showPermission.includes("Customers") && styles.active
                      }`}
                      icon="angle-down"
                      style={{ fontSize: "18px" }}
                    />
                  </div>
                  {showPermission.includes("Customers") && (
                    <div className={styles.permission_item_body}>
                      <div className={styles.permission_value_all}>
                        <primaryComponents.Checkbox
                          isChecked={selectAllCustomers}
                          id={"selectAllCustomers"}
                          name={"selectAllCustomers"}
                          onChange={() => {
                            const permissions = dataPermissionsCategory
                              ?.find((item) => item.label === "Customers")
                              ?.permissions.map((item) => item.id);

                            if (selectAllCustomers) {
                              const notInPermissions =
                                selectedPermissions.filter(
                                  (item) => !permissions.includes(item),
                                );

                              setSelectedPermissions(notInPermissions);
                            } else {
                              setSelectedPermissions([
                                ...new Set([
                                  ...selectedPermissions,
                                  ...permissions,
                                ]),
                              ]);
                            }
                            setSelectAllCustomers(!selectAllCustomers);
                          }}
                        />
                        <p className="ml-2 mt-1">Select All</p>
                      </div>
                      {dataPermissionsCategory
                        ?.find((item) => item.label === "Customers")
                        ?.permissions.map((perm) => (
                          <PermissionCheckBox
                            key={perm.id}
                            perm={perm}
                            selectedPermissions={selectedPermissions}
                            setSelectedPermissions={setSelectedPermissions}
                          />
                        ))}
                    </div>
                  )}
                </div>
                <div className={styles.permission_item}>
                  <div
                    onClick={() =>
                      setShowPermission(
                        showPermission.includes("Settings")
                          ? showPermission.filter((item) => item !== "Settings")
                          : [...new Set([...showPermission, "Settings"])],
                      )
                    }
                    className={styles.permission_item_heading}
                  >
                    <p>Settings</p>
                    <FontAwesomeIcon
                      className={`gray--text ${styles.transform_icon} ${
                        showPermission.includes("Settings") && styles.active
                      }`}
                      icon="angle-down"
                      style={{ fontSize: "18px" }}
                    />
                  </div>
                  {showPermission.includes("Settings") && (
                    <div className={styles.permission_item_body}>
                      <div className={styles.permission_value_all}>
                        <primaryComponents.Checkbox
                          isChecked={selectAllSettings}
                          id={"selectAllSettings"}
                          name={"selectAllSettings"}
                          onChange={() => {
                            const permissions = dataPermissionsCategory
                              ?.find((item) => item.label === "Settings")
                              ?.permissions.map((item) => item.id);

                            if (selectAllSettings) {
                              const notInPermissions =
                                selectedPermissions.filter(
                                  (item) => !permissions.includes(item),
                                );

                              setSelectedPermissions(notInPermissions);
                            } else {
                              setSelectedPermissions([
                                ...new Set([
                                  ...selectedPermissions,
                                  ...permissions,
                                ]),
                              ]);
                            }
                            setSelectAllSettings(!selectAllSettings);
                          }}
                        />
                        <p className="ml-2 mt-1">Select All</p>
                      </div>
                      {dataPermissionsCategory
                        ?.find((item) => item.label === "Settings")
                        ?.permissions.map((perm) => (
                          <PermissionCheckBox
                            key={perm.id}
                            perm={perm}
                            selectedPermissions={selectedPermissions}
                            setSelectedPermissions={setSelectedPermissions}
                          />
                        ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <primaryComponents.Button
              classNames={`btn btn--primary ${styles.btnEdit}`}
              isLoading={isLoadingMutate}
              isDisabled={isLoadingMutate}
              loadingText="Saving..."
              type="submit"
            >
              Save
            </primaryComponents.Button>
          </form>
        </secondaryComponents.LoaderHelper>
      </div>
    </secondaryComponents.Modal>
  );
};

export default EditRoleModal;
